/* eslint-disable import/prefer-default-export */

export class WaEventsConstants {
  static EVENT = 'gaEvent';

  static HITTYPE_EVENT = 'event';

  static CATEGORY_CTA = 'CTA';

  static ACTION_CLUB = 'CLUB';

  static ALTA_ORO = 'ALTA-ORO';

  static ORO = 'ORO';

  static ALTA_ORO_COMPLETAR = 'ALTA-ORO-COMPLETAR';

  static ORO_IMPAGOS = 'ORO-ABONAR-CUOTA';

  static ORO_BAJA = 'BAJA-ORO';

  static CALCULADORA = 'CALCULADORA';

  static DATA_BUTTON_INCOMPLETE = 'edit-data-incomplete';

  static DATA_BUTTON_CONFIRM = 'confirm-sign-up';

  static DATA_JS_SAVING = 'calculate-saving';

  static CATEGORY_MENU_SOLICITAR_TARJETA = 'MENU-SOLICITAR-TARJETA';

  static CATEGORY_TARJETAS_SOLICITAR_ORO = 'TARJETAS-SOLICITAR-ORO';

  static MENU_ORO = 'ORO_FROM_MENU';

  static MENU_MASTERCARD = 'MASTERCARD_FROM_MENU';

  static MASTERCARD = 'MASTERCARD';

  static MENU_SOCIO_CLUB = 'SOCIO_CLUB_FROM_MENU';

  static SOCIO_CLUB = 'EROSKI_CLUB';

  static CLIENTE_CONTACT = 'CONTACTO_CLIENTE';
}
